import React from "react";

const NeueFontStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.04719 6C7.26183 7.94799 7.811 10.0969 7.98429 11.9867M7.98429 11.9867C8.1928 14.2595 7.85768 16.1577 5.74343 16.8807C4.41434 17.3352 2.8234 16.44 3.01593 15.066C3.11204 14.3801 3.49131 13.6751 4.38296 13.1155C4.65122 12.9471 4.95333 12.8405 5.25908 12.7544L7.98429 11.9867ZM7.98429 11.9867L12 10.8556",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 3C13.3793 8.07692 6.13793 2.30769 3 9",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(NeueFontStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;